import { css } from '@emotion/core';
import { typographyStyles, constants } from '@newsela/angelou';

const { textS } = typographyStyles;
const { colors } = constants;

export const $card = css`
    background-color: white;
    margin-bottom: 6px;
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: solid 1px ${colors.ui.core[400]};
    ${textS};
`;
